import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import { api } from '../../../services';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function UploadBonito({ handleFileChange }) {
  const [fileName, setFileName] = useState('Nenhum arquivo escolhido');

  const handleFileChangeLocal = (e) => {
    const file = e.target.files[0];
    handleFileChange(e);
    setFileName(file ? file.name : 'Nenhum arquivo escolhido');
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {/* Input escondido */}
      <input
        id="fileInput"
        type="file"
        style={{ display: 'none' }}
        onChange={handleFileChangeLocal}
      />

      {/* Label estilizado como botão */}
      <label
        htmlFor="fileInput"
        style={{
          background: '#4CAF50',
          color: '#fff',
          padding: '8px 16px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold',
        }}
      >
        Escolher arquivo
      </label>

      {/* Nome do arquivo */}
      <span>{fileName}</span>
    </div>
  );
}

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose = () => {} }, ref) => {
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [id, setId] = useState(0);
    const [linkAtual, setLinkAtual] = useState(0);
    const [nome, setNome] = useState('');
    const [preview, setPreview] = useState(null);
    const [inputKey, setInputKey] = useState(Date.now());
    const [isAlterado, setIsAlterado] = useState(false);

    const handleCloseDialog = () => {
      setOpen(false);
      if (isAlterado) handleClose();
    };

    useImperativeHandle(ref, () => ({
      handleOpen(id, linkAtual, nome) {
        setOpen(true);
        setId(id);
        setLinkAtual(linkAtual);
        setNome(nome);
        setPreview(null);
        setIsAlterado(false);
      },
    }));

    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);

      if (selectedFile) {
        setPreview(URL.createObjectURL(selectedFile));
      } else {
        setPreview(null);
      }
    };

    const handleUpload = async () => {
      if (!file) return alert('Selecione um arquivo!');

      const formData = new FormData();
      formData.append('file', file);

      try {
        const res = await api.post(`/teste-upload-front/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        setLinkAtual(preview);
        setPreview(null);
        setInputKey(Date.now());
        setIsAlterado(true);
      } catch (err) {
        console.error('Erro no upload:', err);
      }
    };

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            {`${nome}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <figure>
                <img src={preview ? preview : linkAtual} alt="Imagem Atual" />
              </figure>
              <br />
              {/* <input type="file" onChange={handleFileChange} key={inputKey} /> */}
              {/* <button onClick={handleUpload} type="button" disabled={!preview}>
                Alterar
              </button> */}

              <UploadBonito
                handleFileChange={handleFileChange}
                key={inputKey}
              />
              <Button
                onClick={handleUpload}
                variant="contained"
                color="primary"
                disabled={!preview}
                style={{
                  marginTop: '20px',
                }}
              >
                Alterar
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
